<template>
    <div class="grid-question-wrapper">
        <div v-if="question" class="grid-question">
            <h2>{{ question.intro }}</h2>
            <div class="content-wrapper">
                <div class="grid-options" :class="{
                    'grid-repeat-2': question.config.options.length >= 2,
                    'grid-repeat-4': question.config.options.length >= 4,
                    'grid-repeat-6': question.config.options.length >= 6,
                    'more-than-2': question.config.options.length > 2
                }">
                    <div v-for="option in question.config.options" :key="option.value">
                        <div>
                            <div :id="'wrapper' + option.value" class="option-wrapper">
                                <label class="start-option-label">
                                    <input :id="option.value" v-model="answers" class="start-option-input d-none"
                                        type="radio" :value="option.value" :disabled="Array.isArray(answers) &&
                                            question.config.max <= answers.length &&
                                            !answers.includes(option.value)
                                            " @click="changeDiv(option.value)" />
                                    <div v-if="option.image" class="start-option-img">
                                        <img :src="option.image.preview ? option.image.preview : option.image
                                            " :alt="option.title" class="card-img-center img-fluid" />
                                    </div>
                                    <span class="start-option-text">{{ option.title }}
                                        <b-button v-if="option.info" variant="link" :id="'popover' + option.value"
                                            class="popover-btn">
                                            <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
                                        </b-button>
                                        <b-popover v-if="option.info" :target="'popover' + option.value"
                                            :content="option.info" triggers="hover focus" placement="topright"
                                            style="background-color: #1a1a1a; color: #ffffff"></b-popover>
                                    </span>
                                    <img src="@/assets/images/diagnosis/green_tick.svg" :id="'tick' + option.value"
                                        class="selected-tick" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'image-question',
    data() {
    return {
      preSelect: "",
    };
  },
    computed: {
        question: function () {
            return this.$store.state.questions[0] || false
        },
        answers: {
            get() {
                return this.question.selectedAnswers ?? "";
            },
            set(value) {
                this.$store.commit("updateSelectedAnswers", value);
            },
        },
    },
    mounted() {
        if (
            this.question.config.max === 1 &&
            this.question.selectedAnswers.length === 0 
        ) {
            this.updateRadio();
        } else {
            this.preSelect = this.question.selectedAnswers;
        }
    },

    methods: {
        activeOption(value) {
            if (this.question.config.max == 1 && value == this.answers) {
                return true;
            }
            if (this.question.config.max > 1 && this.answers.includes(value)) {
                return true;
            }
            return false;
        },
        // update(e) {
        //     if (this.$v.inputtext.validator && this.$v.inputtext.required) {
        //         this.$store.commit('updateSelectedAnswers', { answer: e.target.id, displayValue: this.inputtext });
        //     } else {
        //         this.$store.commit('clearSelectedAnswers');
        //     }
        // },

        changeDiv(id) {
            let list = document.querySelectorAll('[id^="wrapper"]');
            let list2 = document.querySelectorAll('[id^="tick"]');
            let list3 = document.querySelectorAll('[id^="brand"]');
            list.forEach((inp) => {
                inp.style.borderColor = "transparent";
            });
            list2.forEach((inp) => {
                inp.style.display = "none";
            });
            list3.forEach((inp) => {
                inp.style.border = "thin solid #F0F0F0";
            });
            if (list.length !== 0) {
                document.getElementById("wrapper" + id).style.borderColor = "#2DA64F";
            }
            if (list2.length !== 0) {
                document.getElementById("tick" + id).style.display = "unset";
            }
            if (list3.length !== 0) {
                document.getElementById("brand" + id).style.borderColor = "#2DA64F";
            }
        },
        updateRadio() {
            if (
                this.question.selectedAnswers.length === 0 &&
                this.question.config.length !== 0
            ) {
                this.preSelect = this.question.config.options[0].value;
            }
            if (this.preSelect) {
                this.$store.commit("updateSelectedAnswers", this.preSelect);
            }
        },
    },
}
</script>
  